module.exports = __webpack_public_path__ + "static/media/attack-defense.59a791b6.jpg";